import SOURCE_ENUM from 'web/sources/SOURCE_ENUM';

export const sourceKeysMappings = {
  [SOURCE_ENUM.MYSQL]: {
    user: 'User',
    host: 'Host',
    port: 'Port',
    database: 'Database',
    password: 'Password',
    ssl: 'SSL',
  },
  [SOURCE_ENUM.POSTGRES]: {
    user: 'Database User',
    host: 'Host',
    port: 'Port',
    database: 'Database',
    password: 'Database Password',
    ssl: 'SSL',
    pgschema: 'Schema',
  },
  [SOURCE_ENUM.SQLSERVER]: {
    user: 'Database User',
    host: 'Host',
    port: 'Port',
    database: 'Database',
    password: 'Database Password',
    ssl: 'SSL',
    sqlsrvschema: 'Schema',
  },
  [SOURCE_ENUM.SALESFORCE]: {
    instanceName: 'Instance Name',
    accessToken: 'Access Token',
    refreshToken: 'Refresh Token',
    apiType: 'API Type',
    username: 'Username',
    start_date: 'Start Date',
  },
  [SOURCE_ENUM.SALESFORCEV2]: {
    instanceName: 'Instance Name',
    accessToken: 'Access Token',
    refreshToken: 'Refresh Token',
    apiType: 'API Type',
    apiVersion: 'API Version',
    username: 'Username',
    includeFormulaFields: 'Include Formula Fields',
    maxApiQuotaPercentage: 'Max API Quota Percentage',
    pollInterval: 'Polling Interval',
    pollTimeout: 'Polling Timeout',
    start_date: 'Start Date',
  },
  [SOURCE_ENUM.S3]: {
    access_key_id: 'Access Key ID',
    secret_access_key: 'Secret Access Key',
    bucket_name: 'Bucket Name',
    bucket_region: 'Bucket Region',
    assume_role: 'Role ARN',
    assume_role_external_id: 'Role External ID',
    assume_role_session_name: 'Role Session Name',
    start_date: 'Start Date',
    file_path: 'File Path',
    file_regex: 'File Regex',
    file_prefix: 'File Prefix',
    table_name: 'Table Name',
    default_file_type: 'Default File Type',
    columns: 'Source Schema',
  },
};
